import type { IconSvgObject } from './types';

const TextKerningIcon: IconSvgObject = [
  ["path", { d: "M20.0009 18L22.0009 20L20.0009 22M21.2908 20H12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 14.5L18.5 4.5H17.5L14 14.5M15.2929 10.8636H20.7071", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14.5 3L9.5 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M10 4.5L6 14.5L2 4.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default TextKerningIcon;
